<button
  mat-flat-button
  class="new-project-button"
  [routerLink]="['/client-project', 'nieuw', '0']"
  [disabled]="disableCreate"
>
  + Nieuwe bestelling
</button>
<div class="home-page-container">
  <div class="form-title">
    <div class="form-title-text">
      Inpress contactgegevens
    </div>
  </div>
  <div class="home-page-content">
    <client-corner-home-page-inpress-workers></client-corner-home-page-inpress-workers>
  </div>
  <div class="form-title upper-space">
    <div class="form-title-text">
      Logingegevens
    </div>
  </div>
  <div class="home-page-content">
    <client-corner-home-page-company-selector
      (onSelectedCompany)="selectedCompanyChanged($event)"
    ></client-corner-home-page-company-selector>
    <client-corner-home-page-colleague-list
      [selectedCompanyId]="selectedCompanyId"
    ></client-corner-home-page-colleague-list>
  </div>
  <div class="form-title completed-subprojects-margin">
    <div class="form-title-text">
      Laatst uitgevoerde opdrachten
    </div>
  </div>
  <div class="home-page-content">
    <client-corner-home-page-completed-subprojects
      [selectedCompanyId]="selectedCompanyId"
    ></client-corner-home-page-completed-subprojects>
  </div>
</div>

<div *ngIf="disableCreate" class="contact-popup">
  <p>Neem contact op met de boekhouding van Inpress aub</p>
  <a href="mailto:boekhouding@inpress.be">boekhouding@inpress.be</a>
</div>
